import './Separator.css';

function Separator() {
    return (
        <div className="separator-container">
          <div className="separator"></div>
        </div>
    );
}

export default Separator;